// src/templates/search.js
import Layout from "@components/Layout/Layout";
import useHasScrolled from "@hooks/useHasScrolled";
import clsx from "clsx";
import logo from "@images/logo.svg"
import React, { useEffect, useMemo, useState } from "react";
import {
    UserObjectStoreProvider,
    getUserobjectData,
    isAuthenticated,
} from "@starberry/myaccount-website-utils"
import { createResultsCanonicalUrl, getAreaPath, getH1Text, getSeoDesc, parseResultsUrl } from "@lib/searchUtils";
import useInitPropertyData from "@components/SearchResults/hooks/useInitPropertyData";
import { usePropertyStore } from "@components/SearchResults/store/propertyStore";
import { navigate } from "gatsby";
import useTeams from "@hooks/dataHooks/useTeams";
import { resiPropertyTypeOptions } from "@components/SearchResults/SearchFilters/filterOptions";
import { propertiesRentURL, propertiesSaleURL } from "@lib/urls";
import { shuffle } from "lodash";
import RSeo from "@components/resultsseo";
import SearchFilters from "@components/SearchResults/SearchFilters/SearchFilters";
import ResultsBreadcrumb from "@components/PropertyBreadcrumb/ResultsBreadcrumb";
import InfoMapSort from "@components/SearchResults/InfoMapSort/InfoMapSort";
import NoResults from "@components/SearchResults/NoResults/NoResults";
import PropertyCardList from "@components/PropertyCard/PropertyCardList";
import SponsoredProjects from "@components/SponsoredProjects/SponsoredProjects";
import AdsBanner from "@components/AdsBanner/AdsBanner";
import SearchPagination from "@components/SearchResults/SearchPagination/SearchPagination";
import ProjectSpotlight from "@components/PropertyAreaguide/ProjectSpotlight";
import ResidentialPopularSearch from "@components/PopularSearchModule/PopularSearchModule";
import UsefulLInks from "@components/PopularSearchModule/UsefulLInks";
import PropertyNegoCardSR from "@components/PropertyNegoCard/PropertyNegoCardSR";
// import SidebarProjects from "@components/SidebarProjects/SidebarProjects";
import PropertyAreaguideSR from "@components/PropertyAreaguide/PropertyAreaguideSR";
import Cardsidebar from "@components/PopularSearchModule/Cardsidebar";
import SRTeamsSlider from "@components/TeamsSlider/SRTeamsSlider";
import { Container } from "react-bootstrap";
import PropertyMortgageCalc from "@components/PropertyMortgageCalc/PropertyMortgageCalc";
import QuestionnaireBannerCom from "@components/QuestionnaireBannerCom/QuestionnaireBannerCom";
import PropertyCopyV1 from "@components/TextCopy/PropertyCopyV1";
import loadable from "@loadable/component";
import { gtagReportConversion } from "@lib/utils";
import useBrandInfo from "@hooks/dataHooks/useBrandInfo";
const BrightcallSideBar = loadable(() => 
    import("@components/Brightcall/BrightcallSideBar")
)
const Brightcall = loadable(() => 
    import("@components/Brightcall/Brightcall")
)
const PropertyMap = loadable(() =>
    import("@components/SearchResults/map/RenderMap")
)
const Search = ({ serverData, location }) => {
    const { phone } = useBrandInfo()
    const [brignt, setBright] = useState(false)
    const propertyURL = typeof window !== "undefined" ? window.location.pathname : ""
    const pageUrlData = parseResultsUrl(location)
    const memoizedPageUrlData = useMemo(() => pageUrlData, [pageUrlData]);
    const [initLoad, setInitLoad] = useState(true)
    useInitPropertyData()
    const listView = usePropertyStore((state) => state.listView)
    const setListView = usePropertyStore((state) => state.setListView)
    const properties = serverData?.hits
    const offplanProperties = serverData?.projects?.length > 0 && serverData?.projects
    // let sidebarProject = serverData?.projects?.length > 0 && serverData?.projects[0]
    const propertyCopy = serverData?.content?.length > 0 && serverData?.content[0]
    const showMap = usePropertyStore((state) => state.showMap)
    const setShowMap = usePropertyStore((state) => state.setShowMap)
    const pType = usePropertyStore((state) => state.pType)
    const pDepartment = usePropertyStore((state) => state.pDepartment)
    const selectedAreas = usePropertyStore((state) => state.selectedAreas)
    const propertyBanner = "propertySaleBanners"
    const path = typeof window !== "undefined" && window.location.pathname

    useEffect(() => {
        if (typeof window !== "undefined") {
            sessionStorage.setItem("searchpath", path)
        }
    }, [path])
    let h1Text
    if (pageUrlData) {
        h1Text = getH1Text(pageUrlData)
    }

    const { minBedroom } = usePropertyStore()
    const { nbHits, nbPages, page } = {
        nbHits: serverData?.nbHits,
        nbPages: serverData?.nbPages,
        page: serverData?.page,
    }

    const scrolled = useHasScrolled()
    const [isLoad, setLoad] = useState(true)
    const buildingType = usePropertyStore((state) => state.buildingType)
    const dynamicData = useMemo(
        () => ({
            department: pDepartment,
            area:
                selectedAreas?.length > 0
                    ? getAreaPath(selectedAreas)?.replace("in-", "")?.replace("/", "")
                    : "dubai",
            searchType: pType,
            bedroom: minBedroom?.value,
            propertyType: buildingType?.value,
        }),
        [pDepartment, selectedAreas, pType, minBedroom, buildingType]
    )
    const [userObjects, setUserObjects] = useState({})
    useEffect(() => {
        if (localStorage.getItem("listView") !== null) {
            setListView(JSON.parse(localStorage.getItem("listView")))
        }
        let isMounted = true
        if (isAuthenticated()) {
            const getUserObjects = async () => {
                try {
                    const userObjects = await getUserobjectData()
                    if (isMounted) setUserObjects(userObjects.data.data)
                } catch (e) { }
            }
            getUserObjects()
        }
        // Redirect to 404 if the URL is not valid
        let arr = resiPropertyTypeOptions.slice(1).map((item) => {
            return item.value + "-";
        });

        const matchURLs = [
            "above-",
            "below-",
            "between-",
            "from-",
            "to-",
            "under-",
            "more-than-",
            "-bedrooms",
            "-sqft",
            "in-",
            "page-",
            "sortby-",
            "with-amenities-",
            "crm-id-",
            "furnished",
            "completion-",
            "commercial-",
            "map-view"
        ];

        const matchURLs1 = [...arr];
        const matchURLs2 = ["-to-rent-", "-for-sale-"];
        // console.log(matchURLs2.some((matchURL) => path.includes(matchURL)))
        // console.log(path)
        const path2 = path.split("/")[2] || "";
        const path3 = path.split("/")[3] || "";

        // Updated condition to include matchURLs2 check
        if (
            !matchURLs1.some((matchURL) => path2.includes(matchURL)) &&
            !matchURLs.some((matchURL) => path3.includes(matchURL)) &&
            (path !== propertiesSaleURL && path !== propertiesRentURL)

        ) {
            if (typeof window !== "undefined") {
                if (path.includes("/buy/")) {
                    navigate("/buy/properties-for-sale/", { replace: true });
                } else if (path.includes("/let/")) {
                    navigate("/let/properties-for-rent/", { replace: true });
                }
            }
        }
        if (matchURLs2.some((matchURL) => path.includes(matchURL))) {
            if (typeof window !== "undefined") {
                if (path.includes("/buy/")) {
                    navigate("/buy/properties-for-sale/", { replace: true });
                } else if (path.includes("/let/")) {
                    navigate("/let/properties-for-rent/", { replace: true });
                }
            }
        }

        return () => {
            isMounted = false // Cleanup
        }
    }, [isLoad])
    const allTeams = useTeams()
    const filterByCommunity = (teams, communities) => {
        return teams.filter((team) => {
            return communities.some((community) => {
                return team?.community?.strapi_json_value?.some((value) =>
                    value.includes(community.name)
                )
            })
        })
    }
    const [filteredData, setFilteredData] = useState([])
    const memoizedUserObjects = useMemo(() => userObjects, [userObjects]);

    useEffect(() => {
        let filteredDataTemp = []
        if (selectedAreas && selectedAreas.length > 0) {
            filteredDataTemp = filterByCommunity(allTeams, selectedAreas)
        }

        // If no teams were found, check for "Laura Victoria Adams"
        if (filteredDataTemp.length === 0) {
            filteredDataTemp = allTeams.filter(
                (team) => team?.name === "Laura Victoria Adams"
            )
        }
        const shuffledTeams = shuffle(filteredDataTemp)
        setFilteredData(shuffledTeams)
    }, [selectedAreas])
    let { pathname } = location
    const seoDesc = getSeoDesc(pageUrlData)
    const [customCanonical, setCustomCanonical] = useState(
        process.env.GATSBY_SITE_URL + pathname
    )
    const pageurl = typeof window !== "undefined" ? window.location.href : ""
    const listingpage = typeof window !== "undefined" && window.location.href
    var ldJson = {
        "@context": "https://schema.org/",
        "@id": "SearchResultsPage",
        "@type": ["SearchResultsPage", "Product"],
        accessModeSufficient: {
            "@type": "ItemList",
            name: h1Text,
            itemListOrder: "https://schema.org/ItemListOrderDescending",
            numberOfItems: serverData?.nbHits,
            itemListElement: [],
        },
        brand: {
            "@type": "Organization",
            name: "Provident Estate",
        },
        breadcrumb: {
            "@id": pageurl + "#breadcrumb",
            "@type": "BreadcrumbList",
            itemListElement: [
                {
                    "@type": "ListItem",
                    name: "Provident Estate",
                    item: process.env.GATSBY_SITE_URL,
                    position: 1,
                },
                {
                    "@type": "ListItem",
                    name: h1Text,
                    item: listingpage,
                    position: 2,
                },
            ],
        },
        contentLocation: {
            "@type": "Place",
            address: {
                "@type": "PostalAddress",
                addressLocality: "Dubai",
            },
        },
        description: seoDesc,
        image:
            "https://d3h330vgpwpjr8.cloudfront.net/x.dev/1773x/888_4af09da9b9.webp",
        name: h1Text,
        offers: {
            "@type": "AggregateOffer",
            highPrice: "999999999",
            lowPrice: "100000",
            offerCount: serverData?.nbHits,
            priceCurrency: "AED",
        },
        sameAs: "https://en.wikipedia.org/wiki/Search_engine_results_page",
        speakable: {
            "@type": "SpeakableSpecification",
        },
    }

    var ldjson1 = {
        "@context": "http://schema.org",
        "@id": "Organization",
        "@type": ["Organization", "Corporation"],
        logo: "https://www.providentestate.com/images/logo.png",
        url: process.env.GATSBY_SITE_URL,
        brand: {
            "@type": "Brand",
            name: "Provident Estate",
        },
        name: "Provident Estate",
        address: "#1802, 18th Floor, Marina Plaza, Dubai Marina, Dubai, UAE",
        contactPoint: {
            "@type": "ContactPoint",
            telephone: "+971505390249",
            contactType: "customer service",
            areaServed: "ae",
            availableLanguage: ["en", "ar"],
        },
        sameAs: [
            "https://www.facebook.com/providentestate",
            "https://www.instagram.com/providentestate",
            "https://www.linkedin.com/company/providentestate",
            "https://www.youtube.com/@Providentestate",
            "https://twitter.com/providentagents",
        ],
    }

    useEffect(() => {
        const fetchCanonicalUrl = async () => {
            const canonicalUrl = await createResultsCanonicalUrl({ pageUrlData })
            setCustomCanonical(process.env.GATSBY_SITE_URL + canonicalUrl)
        }

        fetchCanonicalUrl()
    }, [pathname, h1Text])

    if (!customCanonical && !pageUrlData) {
        // You can return a loading state or default canonical URL here if needed
        return null
    }

    if (pageUrlData?.layoutVal == "map") {
        setShowMap(true)
    }
    return (
        <UserObjectStoreProvider>
            <Layout
                pageData={{
                    page_class: clsx(
                        "search-results-page",
                        nbHits === 0 && "no-properties-page",
                        scrolled && "search-fit"
                    ),
                    layout: "search-results",
                }}
                hideNewsletter
            >
                {
                    pageUrlData?.layoutVal === "map" ? (
                        <div className={clsx("search-map-wrapper")}>
                            <PropertyMap searchResult={serverData} />
                        </div>
                    ) :
                        <>
                            <div className="se-r min-vh-100">
                                {isLoad && (
                                    <RSeo
                                        customCanonical={
                                            customCanonical || process.env.GATSBY_SITE_URL + pathname
                                        }
                                        title={h1Text}
                                        description={seoDesc}
                                        isproperty
                                        ldJson={ldJson}
                                        ldjson1={ldjson1}
                                    />
                                )}
                                {isLoad && (
                                    <>
                                        <SearchFilters istrue userObjects={memoizedUserObjects}
                                            pageUrlData={memoizedPageUrlData} />

                                        <ResultsBreadcrumb
                                            path={path}
                                            search_type={pType}
                                            isLoad={isLoad}
                                            h1Text={h1Text ? h1Text : ""}
                                            department={pDepartment}
                                        />
                                        <div className={clsx("search-results-section list-page")}>
                                            <InfoMapSort
                                                h1Text={h1Text}
                                                isLoad={isLoad}
                                                istrue
                                                pType={pType}
                                                serverData={serverData}
                                                pageUrlData={pageUrlData}
                                            />
                                            <div
                                                className={clsx(
                                                    "new-layout-with-sidebar container",
                                                    "list-k",
                                                    // nbHits === 0 ||
                                                    (nbHits === 0 && "no-result")
                                                )}
                                            >
                                                <div>
                                                    {nbHits === 0 &&
                                                        <NoResults selectedAreas={selectedAreas} filteredData={filteredData} searchResult={serverData} />
                                                    }
                                                    {/* <PropertyList selectedAreas={selectedAreas} userObjects={userObjects} filteredData={filteredData} /> */}
                                                    {serverData?.nbHits > 0 &&
                                                        <div
                                                            className={`property-list-container`}
                                                        >
                                                            <div
                                                                className={clsx(
                                                                    "property-list-section",
                                                                    listView && "list-view",
                                                                )}
                                                                id={`property-page-${serverData?.page}`}
                                                                key={`property-page-${serverData?.page}`}
                                                            >
                                                                {properties?.map((property, index) => {
                                                                    let indexval
                                                                    if (listView && (index === 2 || index === 5)) {
                                                                        // Calculate the base index for the page
                                                                        let baseIndex = serverData?.page * 2

                                                                        // Determine the offset based on the index (2 comes first, then 7)
                                                                        let offset = index === 2 ? 0 : 1

                                                                        // Calculate indexval with reset after reaching 20
                                                                        indexval = (baseIndex + offset) % 20
                                                                    } else if (!listView && index === 3) {
                                                                        // Calculate the base index for the page
                                                                        let baseIndex = serverData?.page

                                                                        // Determine the offset based on the index (2 comes first, then 7)
                                                                        let offset = index === 3 ? 0 : null

                                                                        // Calculate indexval with reset after reaching 20
                                                                        indexval = baseIndex
                                                                    }
                                                                    let offplanProperty = index === 5 ? offplanProperties[0] : index === 11 ? offplanProperties[1] : []
                                                                    // const showOffplanCard = index === 1 || (index > 1 && (index - 2) % 4 === 0);
                                                                    let showOffplanCard = serverData?.nbHits > 5
                                                                        ? index === 5 || index === 11
                                                                        : index === 5
                                                                    return (
                                                                        property !== null &&
                                                                        <React.Fragment
                                                                            key={`${property?.objectID}-${index}`}
                                                                        >
                                                                            <PropertyCardList
                                                                                address={property?.display_address}
                                                                                description={property?.description}
                                                                                bathrooms={property?.bathroom}
                                                                                bedrooms={property?.bedroom}
                                                                                building={property?.building?.[0]}
                                                                                image={property?.images?.[0]}
                                                                                images={property?.images}
                                                                                price={property?.price}
                                                                                size={property?.floorarea_min}
                                                                                searchType={property?.search_type}
                                                                                slug={property?.slug}
                                                                                crmID={property?.crm_id}
                                                                                bitrix_id={property?.bitrix_id}
                                                                                strapiID={property?.id}
                                                                                showProcessedImage
                                                                                noAnimation
                                                                                listView={listView}
                                                                                email={property?.link_to_employee?.email}
                                                                                crm_negotiator_id={
                                                                                    property?.link_to_employee?.id
                                                                                }
                                                                                longDescription={property?.long_description}
                                                                                department={property?.department}
                                                                                phone={property?.link_to_employee?.phone}
                                                                                name={property?.link_to_employee?.name}
                                                                                singnatureProp={
                                                                                    property?.search_type === "sales" &&
                                                                                    property?.price >= 20000000 &&
                                                                                    property?.department === "residential"
                                                                                }
                                                                                userObjects={userObjects}
                                                                                link_to_employee={
                                                                                    property?.link_to_employee
                                                                                }
                                                                                isListing
                                                                                imageCount={property?.imageCount}
                                                                                property={property}
                                                                            />
                                                                            {showOffplanCard && offplanProperty && (
                                                                                <>
                                                                                    <SponsoredProjects
                                                                                        minsBeds={offplanProperty.min_bedrooms}
                                                                                        maxBeds={offplanProperty.max_bedrooms}
                                                                                        displayBedrooms={
                                                                                            offplanProperty.display_bedrooms
                                                                                        }
                                                                                        buldingType={
                                                                                            offplanProperty.building_type
                                                                                        }
                                                                                        image={
                                                                                            offplanProperty?.ads_image
                                                                                                ? offplanProperty?.ads_image
                                                                                                : offplanProperty.banner_image
                                                                                                    ? offplanProperty.banner_image
                                                                                                    : offplanProperty?.media_images
                                                                                                        ?.length > 0
                                                                                                        ? offplanProperty?.media_images[0]
                                                                                                        : offplanProperty?.images1?.length >
                                                                                                            0
                                                                                                            ? offplanProperty?.images1[0]
                                                                                                            : ""
                                                                                        }
                                                                                        title={offplanProperty.title}
                                                                                        developer={offplanProperty.developer}
                                                                                        location={
                                                                                            offplanProperty.display_address
                                                                                        }
                                                                                        slug={offplanProperty.slug}
                                                                                        videoURL={
                                                                                            offplanProperty?.video_module
                                                                                                ?.video_url
                                                                                        }
                                                                                        community={
                                                                                            offplanProperty?.community?.title
                                                                                        }
                                                                                        key={offplanProperty.id}
                                                                                        completionYear={
                                                                                            offplanProperty.completion_year
                                                                                        }
                                                                                        price={offplanProperty?.price}
                                                                                        listView={true}
                                                                                        description={
                                                                                            index === 5 || index === 11
                                                                                                ? null
                                                                                                : offplanProperty?.about
                                                                                        }
                                                                                        future_launch={
                                                                                            offplanProperty?.future_launch
                                                                                        }
                                                                                        ggfx_results={
                                                                                            offplanProperty?.ggfx_results
                                                                                        }
                                                                                        strapi_id={offplanProperty?.id}
                                                                                        property={offplanProperty}
                                                                                        ads_mobile_image={
                                                                                            offplanProperty?.ads_mobile_image
                                                                                                ? offplanProperty?.ads_mobile_image
                                                                                                : ""
                                                                                        }
                                                                                        isAds={
                                                                                            offplanProperty?.ads_image
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        themeDefault={
                                                                                            index === 5 
                                                                                                ? "dark"
                                                                                                : "light"
                                                                                        }
                                                                                    />
                                                                                </>
                                                                            )}


                                                                            <AdsBanner
                                                                                cardBanner
                                                                                propertyIndex={index}
                                                                                listView={listView}
                                                                                propertyBanner={propertyBanner}
                                                                                isProperty
                                                                                userObjects={userObjects}
                                                                                searchResult={serverData}
                                                                            />

                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>}
                                                    {nbPages >= page && (
                                                        <SearchPagination searchResult={serverData} />
                                                    )}
                                                </div>
                                                {nbHits !== 0 && (
                                                    <div className="side-bar-listing-page">
                                                        <div className="sticky-container">
                                                            <ProjectSpotlight />
                                                            <ResidentialPopularSearch
                                                                dynamicPageData={dynamicData}
                                                            />
                                                            <UsefulLInks />
                                                            <PropertyNegoCardSR team_data={filteredData} />
                                                            <BrightcallSideBar />
                                                            {/* {Object.entries(sidebarProject).length !== 0 && (
                                                                <SidebarProjects
                                                                    minsBeds={sidebarProject.min_bedrooms}
                                                                    maxBeds={sidebarProject.max_bedrooms}
                                                                    displayBedrooms={
                                                                        sidebarProject.display_bedrooms
                                                                    }
                                                                    buldingType={sidebarProject.building_type}
                                                                    image={
                                                                        sidebarProject.ads_image ||
                                                                        sidebarProject.banner_image ||
                                                                        sidebarProject.media_images?.[0] ||
                                                                        sidebarProject.images?.[0] ||
                                                                        ""
                                                                    }
                                                                    title={sidebarProject.title}
                                                                    developer={sidebarProject.developer}
                                                                    location={sidebarProject.display_address}
                                                                    slug={sidebarProject.slug}
                                                                    videoURL={
                                                                        sidebarProject.video_module?.video_url
                                                                    }
                                                                    community={sidebarProject.community?.title}
                                                                    key={sidebarProject.id}
                                                                    completionYear={sidebarProject.completion_year}
                                                                    price={sidebarProject.price}
                                                                    listView={true}
                                                                    description={sidebarProject.about?.data}
                                                                    future_launch={sidebarProject.future_launch}
                                                                    ggfx_results={sidebarProject.ggfx_results}
                                                                    strapi_id={sidebarProject.id}
                                                                    property={sidebarProject}
                                                                    ads_sidebar_image={
                                                                        sidebarProject?.ads_sidebar_image
                                                                            ? sidebarProject?.ads_sidebar_image
                                                                            : ""
                                                                    }
                                                                />
                                                            )} */}
                                                            {selectedAreas?.length > 0 && (
                                                                <PropertyAreaguideSR
                                                                    areas={
                                                                        selectedAreas?.length > 0 ? selectedAreas : []
                                                                    }
                                                                />
                                                            )}
                                                            <Cardsidebar pType={"sale"} />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {nbHits > 0 &&
                                            <SRTeamsSlider
                                                heading={`Contact Property Expert in ${selectedAreas?.length > 0
                                                    ? selectedAreas?.map((area) => area.name).join(",")
                                                    : "Dubai"
                                                    }`}
                                                area={
                                                    selectedAreas?.length > 0
                                                        ? selectedAreas
                                                        : [{ name: "dubai" }]
                                                }
                                            />
                                        }
                                    </>
                                )}
                            </div>
                            {isLoad && (
                                <>
                                    <div className="results-calculator section-m">
                                        <Container>
                                            <PropertyMortgageCalc
                                                pageComp
                                                heading="Mortgage Calculator"
                                                title="Calculate your monthly mortgage repayments"
                                            />
                                        </Container>
                                    </div>
                                    <Container>
                                        <QuestionnaireBannerCom />
                                    </Container>
                                    <PropertyCopyV1
                                        // pType={pType}
                                        // buildingType={buildingType}
                                        // pDepartment={pDepartment}
                                        // selectedAreas={selectedAreas}
                                        propertyCopy={propertyCopy}
                                        isProperty

                                    />
                                </>
                            )}
                        </>
                }
                 <a
                              href="javascript:void(0);"
                              className="bright-cta"
                              onClick={() => 
                                {
                                  gtagReportConversion(`tel:${phone}`)
                                  setBright(true)
                                }
                                 }
                            >
                                <div className="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M1.875 5.625C1.875 12.5286 7.47144 18.125 14.375 18.125H16.25C17.2855 18.125 18.125 17.2855 18.125 16.25V15.107C18.125 14.6768 17.8322 14.3018 17.4149 14.1975L13.7289 13.276C13.363 13.1845 12.9778 13.3212 12.7515 13.623L11.943 14.701C11.7083 15.0139 11.3025 15.1522 10.9353 15.0177C8.17949 14.0082 5.9918 11.8205 4.9823 9.06472C4.84778 8.69749 4.98613 8.29165 5.299 8.057L6.37702 7.24849C6.67878 7.02217 6.81551 6.63704 6.72403 6.27111L5.80253 2.58512C5.69819 2.16778 5.32321 1.875 4.89302 1.875H3.75C2.71447 1.875 1.875 2.71447 1.875 3.75V5.625Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                </div>
                                <div className="text">
                                    <div className="tit">Get a call within 55 seconds</div>
                                    <div className="cta"><span>Click here</span> to get started</div>
                                </div>
                                </a>
                {brignt && <Brightcall setBright={setBright} propertyURL={propertyURL}/>}
            </Layout>
        </UserObjectStoreProvider>
    );
};

export default Search;